




















import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick,
  useStore,
  computed,
} from '@nuxtjs/composition-api'
import SidebarBlock from '../Blocks/SidebarBlock.vue'
import BrandMediaBreadcrumbs from '../UI/BrandMediaBreadcrumbs.vue'

export default defineComponent({
  components: { BrandMediaBreadcrumbs, SidebarBlock },
  setup() {
    const store = useStore()

    const isProstoArticle = computed(
      () => store.getters['settings/getIsProstoArticle']
    )

    const containerRef = ref<HTMLElement | null>(null)

    return {
      containerRef,
      isProstoArticle,
    }
  },
})
